module.exports = {"320724100":"新安镇","320724101":"堆沟港镇","320724102":"田楼镇","320724103":"北陈集镇","320724104":"张店镇","320724105":"三口镇","320724106":"孟兴庄镇","320724107":"汤沟镇","320724108":"百禄镇","320724109":"新集镇","320724110":"李集镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320724.json
// module id = 990
// module chunks = 0